"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerInstructionTypes = exports.InnerProgramTypes = exports.getTransferAmountFromInnerInstructions = exports.getTradeTransactionsFromSignatures = exports.getTradeActivitiesBySignatures = exports.getTradeActivities = void 0;
const types_1 = require("../types");
const getTradeActivities = ({ programId, 
//   fromThisSignature,
untilThisSignature, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
    const LIMIT = 100;
    let allSignaturesInfos = [];
    const currentLastSignatureInfo = (yield connection.getConfirmedSignaturesForAddress2(programId, {
        limit: 1,
    }, 'confirmed'))[0];
    let currentLastSignature = currentLastSignatureInfo.signature;
    if (currentLastSignature == untilThisSignature)
        return [];
    let newSignatureInfosLatestToPast = yield connection.getConfirmedSignaturesForAddress2(programId, {
        limit: LIMIT,
        before: currentLastSignature,
        until: untilThisSignature,
    }, 'confirmed');
    if (newSignatureInfosLatestToPast.length == 0)
        return [];
    currentLastSignature = newSignatureInfosLatestToPast[newSignatureInfosLatestToPast.length - 1].signature;
    allSignaturesInfos = [...allSignaturesInfos, ...newSignatureInfosLatestToPast, currentLastSignatureInfo].filter((signatureInfo) => !signatureInfo.err);
    while (newSignatureInfosLatestToPast.length === LIMIT) {
        newSignatureInfosLatestToPast = yield connection.getConfirmedSignaturesForAddress2(programId, {
            limit: LIMIT,
            before: currentLastSignature,
            until: untilThisSignature,
        }, 'confirmed');
        currentLastSignature = newSignatureInfosLatestToPast[newSignatureInfosLatestToPast.length - 1].signature;
        allSignaturesInfos = [...allSignaturesInfos, ...newSignatureInfosLatestToPast].filter((signatureInfo) => !signatureInfo.err);
    }
    const tradeTransactions = yield (0, exports.getTradeTransactionsFromSignatures)({
        signatures: allSignaturesInfos.map((signatureInfo) => signatureInfo.signature),
        connection,
    });
    let allTradeActivities = [];
    //   console.log('tradeTransactions: ', tradeTransactions.length);
    for (let tradeTxn of tradeTransactions) {
        const tradeActivities = yield parseTransactionInfoToTradeActivities({ tradeTxn, connection });
        allTradeActivities = [...allTradeActivities, ...tradeActivities];
    }
    return allTradeActivities;
});
exports.getTradeActivities = getTradeActivities;
const getTradeActivitiesBySignatures = ({ signatures, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
    const tradeTransactions = yield (0, exports.getTradeTransactionsFromSignatures)({
        signatures,
        connection,
    });
    let allTradeActivities = [];
    for (let tradeTxn of tradeTransactions) {
        const tradeActivities = yield parseTransactionInfoToTradeActivities({ tradeTxn, connection });
        allTradeActivities = [...allTradeActivities, ...tradeActivities];
    }
    return allTradeActivities;
});
exports.getTradeActivitiesBySignatures = getTradeActivitiesBySignatures;
const getTradeTransactionsFromSignatures = ({ signatures, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
    const tradeTransactions = [];
    for (let signature of signatures) {
        const currentTransactionInfo = yield connection.getParsedTransaction(signature, {
            commitment: 'confirmed',
            maxSupportedTransactionVersion: 0,
        });
        if (!currentTransactionInfo || !isTradeTransactionInfo(currentTransactionInfo))
            continue;
        tradeTransactions.push(currentTransactionInfo);
    }
    return tradeTransactions;
});
exports.getTradeTransactionsFromSignatures = getTradeTransactionsFromSignatures;
const isTradeTransactionInfo = (currentTransactionInfo) => {
    var _a, _b;
    return ((_b = (_a = currentTransactionInfo.meta) === null || _a === void 0 ? void 0 : _a.logMessages) === null || _b === void 0 ? void 0 : _b.find(isTradeInstructionLog)) !== undefined;
};
const parseTransactionInfoToTradeActivities = ({ tradeTxn, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    //   console.log(currentTransactionInfo);
    const instructionLogs = (_b = (_a = tradeTxn.meta) === null || _a === void 0 ? void 0 : _a.logMessages) === null || _b === void 0 ? void 0 : _b.reduce((instructionLogs, log) => (isBondInstructionLog(log) ? [...instructionLogs, log] : instructionLogs), []);
    const programInstructionsRaw = tradeTxn.transaction.message.instructions;
    const innerInstructions = (_c = tradeTxn.meta) === null || _c === void 0 ? void 0 : _c.innerInstructions;
    const programInstructions = programInstructionsRaw;
    const tradeActivities = [];
    for (let i = 0; i < innerInstructions.length; i++) {
        const currentLog = instructionLogs[i];
        if (!isTradeInstructionLog(currentLog))
            continue;
        const currentInnerInstruction = innerInstructions[i];
        const currentProgramInstruction = programInstructions[i];
        const currentSignature = tradeTxn.transaction.signatures[0];
        const blockTime = tradeTxn.blockTime;
        if (!TRADE_TRANSACTION_PARSERS[currentLog])
            continue;
        const parsedTradeActivity = yield TRADE_TRANSACTION_PARSERS[currentLog]({
            innerInstruction: currentInnerInstruction,
            programInstruction: currentProgramInstruction,
            signature: currentSignature,
            transaction: tradeTxn,
            blockTime,
            connection,
        });
        if (!parsedTradeActivity)
            continue;
        tradeActivities.push(parsedTradeActivity);
    }
    return tradeActivities;
});
const isTradeInstructionLog = (log) => log === TradeInstruction.BuyNftFromPair || log === TradeInstruction.SellNftToTokenToNftPair;
const isBondInstructionLog = (log) => log === TradeInstruction.BuyNftFromPair ||
    log === TradeInstruction.SellNftToTokenToNftPair ||
    log === TradeInstruction.CreateBondWithSingleCollateral;
const isInstructionLog = (log) => log.startsWith('Program log: Instruction:');
var TradeInstruction;
(function (TradeInstruction) {
    TradeInstruction["BuyNftFromPair"] = "Program log: Instruction: BuyNftFromPair";
    TradeInstruction["SellNftToTokenToNftPair"] = "Program log: Instruction: SellNftToTokenToNftPair";
    TradeInstruction["CreateBondWithSingleCollateral"] = "Program log: Instruction: CreateBondWithSingleCollateral";
})(TradeInstruction || (TradeInstruction = {}));
const TRADE_TRANSACTION_PARSERS = {
    [TradeInstruction.BuyNftFromPair]: ({ innerInstruction, programInstruction, signature, blockTime, transaction, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
        var _d, _e, _f, _g;
        const solAmount = (0, exports.getTransferAmountFromInnerInstructions)(innerInstruction);
        const orderType = types_1.OrderType.Buy;
        const pair = programInstruction.accounts[1];
        const userTaker = programInstruction.accounts[2];
        const userMaker = programInstruction.accounts[9];
        const nftMint = programInstruction.accounts[6];
        const preMintTokenBalance = (_e = (_d = transaction.meta) === null || _d === void 0 ? void 0 : _d.preTokenBalances) === null || _e === void 0 ? void 0 : _e.find((preBalance) => preBalance.mint === nftMint.toBase58());
        if (!preMintTokenBalance) {
            return {
                timestamp: blockTime,
                signature: signature,
                pair: pair ? pair.toBase58() : '',
                orderType: orderType,
                pairType: null,
                nftMint: nftMint ? nftMint.toBase58() : '',
                solAmount: solAmount,
                amountOfTokens: 0,
                userMaker: userMaker ? userMaker.toBase58() : '',
                userTaker: userTaker ? userTaker.toBase58() : '',
            };
        }
        const postMintTokenBalance = (_g = (_f = transaction.meta) === null || _f === void 0 ? void 0 : _f.postTokenBalances) === null || _g === void 0 ? void 0 : _g.find((preBalance) => preBalance.mint === nftMint.toBase58());
        const amountOfTokens = Math.abs(preMintTokenBalance.uiTokenAmount.uiAmount - (postMintTokenBalance === null || postMintTokenBalance === void 0 ? void 0 : postMintTokenBalance.uiTokenAmount.uiAmountString));
        return {
            timestamp: blockTime,
            signature: signature,
            pair: pair ? pair.toBase58() : '',
            orderType: orderType,
            pairType: null,
            nftMint: nftMint ? nftMint.toBase58() : '',
            solAmount: solAmount,
            amountOfTokens: amountOfTokens,
            userMaker: userMaker ? userMaker.toBase58() : '',
            userTaker: userTaker ? userTaker.toBase58() : '',
        };
    }),
    [TradeInstruction.SellNftToTokenToNftPair]: ({ innerInstruction, programInstruction, signature, blockTime, transaction, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
        var _h, _j, _k, _l;
        const solAmount = (0, exports.getTransferAmountFromInnerInstructions)(innerInstruction);
        const orderType = types_1.OrderType.Sell;
        const pair = programInstruction.accounts[0];
        const userTaker = programInstruction.accounts[2];
        const userMaker = programInstruction.accounts[7];
        const nftMint = programInstruction.accounts[3];
        const preMintTokenBalance = (_j = (_h = transaction.meta) === null || _h === void 0 ? void 0 : _h.preTokenBalances) === null || _j === void 0 ? void 0 : _j.find((preBalance) => preBalance.mint === nftMint.toBase58());
        if (!preMintTokenBalance) {
            return {
                timestamp: blockTime,
                signature: signature,
                pair: pair ? pair.toBase58() : '',
                orderType: orderType,
                pairType: null,
                nftMint: nftMint ? nftMint.toBase58() : '',
                solAmount: solAmount,
                amountOfTokens: 0,
                userMaker: userMaker ? userMaker.toBase58() : '',
                userTaker: userTaker ? userTaker.toBase58() : '',
            };
        }
        const postMintTokenBalance = (_l = (_k = transaction.meta) === null || _k === void 0 ? void 0 : _k.postTokenBalances) === null || _l === void 0 ? void 0 : _l.find((preBalance) => preBalance.mint === nftMint.toBase58());
        const amountOfTokens = Math.abs(preMintTokenBalance.uiTokenAmount.uiAmount - (postMintTokenBalance === null || postMintTokenBalance === void 0 ? void 0 : postMintTokenBalance.uiTokenAmount.uiAmountString));
        return {
            timestamp: blockTime,
            signature: signature,
            pair: pair ? pair.toBase58() : '',
            orderType: orderType,
            pairType: types_1.PairType.TokenForNFT,
            nftMint: nftMint ? nftMint.toBase58() : '',
            solAmount: solAmount,
            amountOfTokens,
            userMaker: userMaker ? userMaker.toBase58() : '',
            userTaker: userTaker ? userTaker.toBase58() : '',
        };
    }),
};
const getTransferAmountFromInnerInstructions = (innerInstruction) => {
    return innerInstruction.instructions
        .filter((instruction) => instruction.program === InnerProgramTypes.System)
        .filter((instruction) => instruction.parsed.type === InnerInstructionTypes.Transfer)
        .reduce((amount, instruction) => {
        return amount + instruction.parsed.info.lamports;
    }, 0);
};
exports.getTransferAmountFromInnerInstructions = getTransferAmountFromInnerInstructions;
var InnerProgramTypes;
(function (InnerProgramTypes) {
    InnerProgramTypes["System"] = "system";
    InnerProgramTypes["SplToken"] = "spl-token";
})(InnerProgramTypes = exports.InnerProgramTypes || (exports.InnerProgramTypes = {}));
var InnerInstructionTypes;
(function (InnerInstructionTypes) {
    InnerInstructionTypes["Transfer"] = "transfer";
})(InnerInstructionTypes = exports.InnerInstructionTypes || (exports.InnerInstructionTypes = {}));
